export default __webpack_public_path__ + "static/media/early-payments-usecase1.80926c9a.png";